export enum CupStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	DELETED = "DELETED",
}

export interface ICup {
	_id: string;
	accountId: string;
	name: string;
	vendor: string;
	display: string;
	description: string;
	analytes: string[] | IAnalyteInCup[];
	status: CupStatus;
	isDeleted: boolean;
	createdBy: string;
	updatedBy?: string;
	createdAt: Date;
	updatedAt: Date;
}

export interface CupResponse extends Omit<ICup, "analytes"> {
	analytes: IAnalyteInCup[];
}

export interface IAnalyteInCup {
	_id: string;
	shortname: string;
	scientificName: string;
	shortnameDisplay: string;
	scientificDisplay: string;
	type: string;
}

export interface CupsResponse {
	statusCode: number;
	body: CupResponse[];
}

export interface CupsPaginatedResponse {
	statusCode: number;
	body: {
		data: CupResponse[];
		pagination: {
			currentPage: number;
			pageSize: number;
			totalCount: number;
			totalPages: number;
		};
	};
}
